import React from "react";
import { Stack, Text, Checkbox, Paper, Title } from "@mantine/core";
import { useSalon } from "../../context/SalonContext";

interface AdjustmentFormServicesStepProps {
  selectedServiceIds: string[];
  onToggleService: (serviceId: string) => void;
}

function AdjustmentFormServicesStep({
  selectedServiceIds,
  onToggleService,
}: AdjustmentFormServicesStepProps) {
  const { services } = useSalon() as any;

  // Group services by type
  const groupServicesByType = (services: any[]) => {
    if (!services) return {};

    return services.reduce((groups: any, service: any) => {
      const type = service.service_type || "Other";
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(service);
      return groups;
    }, {});
  };

  const groupedServices = groupServicesByType(services);

  return (
    <Stack gap="md">
      <Title order={4}>Connect to Services</Title>
      <Text size="sm" c="dimmed">
        Select which services should use this adjustment form (optional)
      </Text>

      {Object.keys(groupedServices).length === 0 ? (
        <Paper withBorder p="lg" radius="md">
          <Text c="dimmed" ta="center">
            No services available. Create services first to connect them to this
            form.
          </Text>
        </Paper>
      ) : (
        <Stack gap="lg">
          {Object.entries(groupedServices).map(
            ([type, typeServices]: [string, any]) => (
              <Stack key={type} gap="xs">
                <Text fw={500} size="md" c="dimmed">
                  {type}
                </Text>
                <Paper withBorder p="sm" radius="md">
                  <Stack gap="xs">
                    {typeServices.map((service: any) => (
                      <Checkbox
                        key={service.id}
                        label={service.name}
                        checked={selectedServiceIds.includes(service.id)}
                        onChange={() => onToggleService(service.id)}
                      />
                    ))}
                  </Stack>
                </Paper>
              </Stack>
            ),
          )}
        </Stack>
      )}
    </Stack>
  );
}

export default AdjustmentFormServicesStep;
